import { Tooltip } from './Tooltip';

const statusStyles: Record<string, string> = {
  OPEN:             'bg-status-open text-white',
  LOCKED:           'bg-status-locked text-white',
  PENDING_DEPOSITS: 'bg-amber-500 text-white',
  FILLED:           'bg-status-filled text-white',
  ACCEPTED:         'bg-status-filled text-white',
  COUNTERED:        'bg-amber-600 text-white',
  REJECTED:         'bg-status-closed text-white',
  REFUNDED:         'bg-status-closed text-white',
  CANCELED:         'bg-status-closed text-white',
  CANCELLED:        'bg-status-closed text-white',
  WITHDRAWN:        'bg-status-closed text-white',
  EXPIRED:          'bg-status-closed text-white',
};

const statusLabels: Record<string, string> = {
  OPEN:             'Open',
  LOCKED:           'In Escrow',
  PENDING_DEPOSITS: 'Awaiting Deposit',
  FILLED:           'Filled',
  ACCEPTED:         'Accepted',
  COUNTERED:        'Countered',
  REJECTED:         'Rejected',
  REFUNDED:         'Refunded',
  CANCELED:         'Cancelled',
  CANCELLED:        'Cancelled',
  WITHDRAWN:        'Withdrawn',
  EXPIRED:          'Expired',
};

const statusTooltips: Partial<Record<string, string>> = {
  LOCKED: 'Held securely by a smart contract until the deal completes.',
};

export function StatusBadge({ status }: { status: string }) {
  const style = statusStyles[status] ?? 'bg-disabled text-white';
  const label = statusLabels[status] ?? status;
  const tip = statusTooltips[status];
  const badge = (
    <span
      className={`inline-block px-2 py-0.5 rounded text-[0.7rem] font-bold uppercase tracking-wide ${style}`}
      aria-label={`Status: ${label}`}
    >
      {label}
    </span>
  );
  return tip ? <Tooltip content={tip}>{badge}</Tooltip> : badge;
}
